import axios from "axios";


import {
  errorHandler,
  requestInterceptor,
  successHandler,
} from "./interceptor";
import { API_URL } from "./constants";
import { encodeQuery, JsonRequestHeaders, serialize } from "./formHelper";



// request interceptor
axios.interceptors.request.use((request) => requestInterceptor(request));
// response interceptor
axios.interceptors.response.use(
  (response) => successHandler(response),
  (error) => errorHandler(error)
);


export default class Request {
  /**
   * Getter function to get API URL.
   *
   * @returns {string}
   */
  static get apiUrl() {
    return API_URL;
  }

  /**
   * Function to send GET request.
   *
   * @param url
   * @param queryParams
   * @returns {Promise<AxiosResponse<any>>}
   */
  static get = function (url, queryParams = {}, config = {}) {
    let searchParams = '';
    if (Object.keys(queryParams).length !== 0) {
      searchParams =
        '?' +
        new URLSearchParams(queryParams).toString();
    }
    return axios.get(this.apiUrl + url + searchParams, config);
  };

  /**
   * Function to send POST request. Just pass a JavaScript object to this function,
   * it will automatically convert it into FormData object.
   *
   * @param url
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  static post = function (url, payload, config = {}) {
    const body = serialize(payload);
    const baseUrl = this.apiUrl;
    return axios.post(baseUrl + url, body, config);
  };

  /**
   * Function to send JSON data via POST request.
   *
   * @param url
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  static postJson = (url, payload, queryParams = {}, config = {}) => {
    const baseUrl = this.apiUrl;
    let searchParams = '';
    if (Object.keys(queryParams).length !== 0) {
      searchParams =
        '?' +
        new URLSearchParams(queryParams).toString();
    }

    return axios.post(baseUrl + url + searchParams, payload, {
      ...config,
      headers: {...JsonRequestHeaders, ...config.headers},
    });
  };

  /**
   * Function to send PUT request. Just pass a JavaScript object to this function,
   * it will automatically convert it into FormData object.
   *
   * @param url
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  static put = function (url, payload) {
    const body = serialize(payload);
    return axios.put(this.apiUrl + url, body);
    // return axios.put(url, body);
  };
  static patch = function (url, payload) {
    const body = serialize(payload);
    return axios.patch(this.apiUrl + url, body);
    // return axios.patch(url, body);
  };

  /**
   * Function to send JSON data via PUT request.
   *
   * @param url
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  static putJson = (url, payload, queryParams = {}, config = {}) => {
    let searchParams = '';
    if (Object.keys(queryParams).length !== 0) {
      searchParams =
        '?' +
        new URLSearchParams(queryParams).toString();
    }
    return axios.put(this.apiUrl + url + searchParams, payload, {
      headers: JsonRequestHeaders,
    });
  };

  static patchJson = (url, payload, queryParams = {}, config = {}) => {
    let searchParams = '';
    if (Object.keys(queryParams).length !== 0) {
      searchParams =
        '?' +
        new URLSearchParams(queryParams).toString();
    }
    return axios.patch(this.apiUrl + url + searchParams, payload, {
      headers: JsonRequestHeaders,
    });
  };

  /**
   * Function to send DELETE request.
   *
   * @param url
   * @returns {Promise<AxiosResponse<any>>}
   */
  static delete = function (url, queryParams = {}, config = {}) {
    let searchParams = '';
    if (Object.keys(queryParams).length !== 0) {
      searchParams =
        '?' +
        new URLSearchParams(queryParams).toString();
    }
    return axios.delete(this.apiUrl + url + searchParams, config);
    // return axios.delete(url);
  };

  /**
   * Function to send DELETE request with JSON body.
   *
   * @param url
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  static deleteJson = function (url, payload) {
    return axios.delete(this.apiUrl + url, {
      headers: JsonRequestHeaders,
      data: payload
    });
  };



  /**
   * Helper function to convert array/objects into FormData object.
   *
   * @param {object}payload
   * @returns {FormData}
   */
  static getFormData = function (payload) {
    return serialize(payload);
  };

  /**
   * Function to download a file via GET request.
   *
   * @param url
   * @param fileName
   * @param queryParams
   * @returns {Promise<AxiosResponse<any>>}
   */
  //   static downloadFileViaGet = (
  //     url,
  //     fileName,
  //     queryParams = "",
  //     addBaseURL = true
  //   ) => {
  //     queryParams = queryParams ? `?${encodeQuery(queryParams)}` : "";
  //     return axios
  //       .get((addBaseURL ? this.apiUrl : "") + url + queryParams, {
  //         responseType: "blob",
  //       })
  //       .then((response) => {
  //         const manipulatedFilename =
  //           response?.headers.get("filename") ||
  //           fileName ||
  //           dayjs().format("DD-MM-YYYY");
  //         downloadBlobData(manipulatedFilename, response.data);
  //       })
  //       .catch((error) => {
  //         console.log("Error: ", error);
  //         Notification.error(error?.response?.statusText);
  //       });
  //   };

  //   static downloadFileViaPost = (url, fileName, payload) => {
  //     return axios
  //       .post(this.apiUrl + url, payload, { responseType: "blob" })
  //       .then((response) => {
  //         downloadBlobData(fileName, response.data);
  //       })
  //       .catch((error) => {
  //         console.log("Error: ", error);
  //         Notification.error(error?.response?.statusText);
  //       });
  //   };
}
